import * as types from '../types.js';

/**
 * Grade Doca Expedição — mesmo padrão visual de Saídas / Caixas Picking.
 */
export default async function (records)
{
	return `
		<style>
			.view th:nth-child(1)	{ width: 1rem; }
			.view td:nth-child(2)	{ text-align: left; max-width: 10rem; }
			.view td:nth-child(3)	{ text-align: right; }
			.view td:nth-child(4)	{ text-align: right; }
			.view td:nth-child(5)	{ text-align: left; max-width: 14rem; }
			.view td:nth-child(6)	{ text-align: left; max-width: 12rem; }
			.view td:nth-child(7)	{ text-align: left; max-width: 12rem; }
			.view td:nth-child(8)	{ text-align: left; max-width: 14rem; }
			.view td:nth-child(9)	{ text-align: left; max-width: 12rem; }
			.view td:nth-child(10)	{ text-align: center; }
			.view td:nth-child(11)	{ text-align: left; }
			.dock-pos-ok { color: #166534; }
			.dock-pos-missing { color: #a30; font-style: italic; }
		</style>
		<table class="view">
			<thead>
				<tr>
					<th><input type="checkbox" title="Limpar seleções"></th>
					<th data-index="0" data-visible="${this.visible[0]}">Empresa</th>
					<th data-index="1" data-visible="${this.visible[1]}">Saída</th>
					<th data-index="2" data-visible="${this.visible[2]}">Pedido</th>
					<th data-index="3" data-visible="${this.visible[3]}">Referência</th>
					<th data-index="4" data-visible="${this.visible[4]}">Cliente</th>
					<th data-index="5" data-visible="${this.visible[5]}">Transportadora</th>
					<th data-index="6" data-visible="${this.visible[6]}">Armazém Expedição</th>
					<th data-index="7" data-visible="${this.visible[7]}">Posição Expedição</th>
					<th data-index="8" data-visible="${this.visible[8]}">Status</th>
					<th data-index="9" data-visible="${this.visible[9]}">Criação</th>
				</tr>
			</thead>
			<tbody>
			` + (await Promise.all((records || []).map(async (record) =>
			{
				const rowId = JSON.stringify([record.company_id, record.id]);
				const companyNick = await this.key('companies', record.company_id, 'nick') || '';
				const customerNick = record.customer_nick
					|| (await this.key('customers', record.customer_id ? [record.company_id, record.customer_id] : null, 'nick'))
					|| record.customer_name
					|| '';
				const carrierNick = record.carrier_nick
					|| (await this.key('carriers', record.carrier_id ? [record.company_id, record.carrier_id] : null, 'nick'))
					|| record.carrier_name
					|| '';
				const whName = record.dock_warehouse_name
					|| (record.dock_warehouse_id
						? (await this.key('warehouses', [record.company_id, record.dock_warehouse_id]) || '')
						: '');
				const addr = record.dock_address || '';
				const hasDock = Boolean(addr || (record.dock_warehouse_id && record.dock_location_id));
				return `<tr data-id='${rowId}'>
					<td><input type="checkbox"${this.isChecked(rowId)}></td>
					<td data-visible='${this.visible[0]}'>${companyNick}</td>
					<td data-visible='${this.visible[1]}'>${record.id}</td>
					<td data-visible='${this.visible[2]}'>${record.order_id ?? ''}</td>
					<td data-visible='${this.visible[3]}'>${record.reference || ''}</td>
					<td data-visible='${this.visible[4]}'>${customerNick}</td>
					<td data-visible='${this.visible[5]}'>${carrierNick}</td>
					<td data-visible='${this.visible[6]}'>${whName}</td>
					<td data-visible='${this.visible[7]}' class="${hasDock ? 'dock-pos-ok' : 'dock-pos-missing'}">${hasDock ? (addr || '—') : 'Sem posição'}</td>
					<td data-visible='${this.visible[8]}'>${this.option(types.opt_output_status(), record.status) || ''}</td>
					<td data-visible='${this.visible[9]}'>${this.format(types.datetime(), record.created_on) || ''}</td>
				</tr>`;
			}))).join('') + `
			</tbody>
		</table>
	`;
}
